var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDroneHalf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 67,
    viewBox: "0 0 64 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.275 20.1748H94.9208H83.5667C79.9333 20.1748 79.9333 25.3694 83.5667 25.3694H92.1958V32.5966H76.5271V28.7571C76.5271 24.0143 72.6667 20.1748 67.8979 20.1748H41.1021C36.3333 20.1748 32.4729 24.0143 32.4729 28.7571V32.5966H16.8042V25.3694H25.4333C29.0667 25.3694 29.0667 20.1748 25.4333 20.1748H14.0792H2.725C-0.908333 20.1748 -0.908333 25.3694 2.725 25.3694H11.3542V32.5966H8.40208C4.76875 32.5966 4.76875 38.017 8.40208 38.017H33.1542C33.8354 39.8238 35.425 41.4047 37.0146 42.3081L27.25 49.3095C26.5688 49.7612 26.1146 50.6646 26.1146 51.568V63.9898C26.1146 67.6034 31.5646 67.6034 31.5646 63.9898V52.9231L40.4208 46.5993L42.2375 50.8905C42.4646 52.0197 43.6 52.6973 44.7354 52.6973H64.2646C65.4 52.6973 66.5354 52.0197 66.7625 50.8905L68.5792 46.5993L77.4354 52.9231V63.9898C77.4354 67.6034 82.8854 67.6034 82.8854 63.9898V51.568C82.8854 50.6646 82.4313 49.7612 81.75 49.3095L71.9854 42.3081C73.575 41.4047 75.1646 39.8238 75.8458 38.017H100.598C104.231 38.017 104.231 32.5966 100.598 32.5966H97.6458V25.3694H106.275C109.908 25.3694 109.908 20.1748 106.275 20.1748ZM62.4479 47.2768H46.5521L44.9625 43.4374H64.0375L62.4479 47.2768ZM71.0771 34.6292C71.0771 36.436 69.7146 38.017 67.8979 38.017H41.1021C39.2854 38.017 37.9229 36.436 37.9229 34.6292V28.7571C37.9229 26.9503 39.2854 25.3694 41.1021 25.3694H67.8979C69.7146 25.3694 71.0771 26.9503 71.0771 28.7571V34.6292Z",
    fill: "#3C3C3C",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.219 12.2701C57.9044 7.97897 51.0919 7.97897 46.7773 12.2701C44.5065 14.3028 47.6856 17.4647 49.9565 15.432C52.4544 12.9477 56.5419 12.9477 59.0398 15.432C61.0836 17.4647 64.4898 14.3028 62.219 12.2701Z",
    fill: "#3C3C3C",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.5762 5.94624C60.8554 -1.50682 48.1387 -1.50682 40.4179 5.94624C38.3741 8.20474 41.5533 11.3666 43.8241 9.334C49.7283 3.46189 59.2658 3.46189 65.1699 9.334C67.4408 11.3666 70.6199 8.20474 68.5762 5.94624Z",
    fill: "#3C3C3C",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDroneHalf);
export default __webpack_public_path__ + "static/media/drone-half.97c946383449c5b489fd6f1b6fcbf7c3.svg";
export { ForwardRef as ReactComponent };